import React, { useEffect } from 'react';
import { useUploadJobs, restoreSavedUploads } from '../utils/uploadQueue';

// Header status chip for the app-wide document upload queue. Shown on every
// screen while uploads are still being processed in the background, so the user
// can work elsewhere and still see how far along they are.
const UploadQueueIndicator: React.FC = () => {
  const jobs = useUploadJobs();
  // This chip is in the header of every signed-in screen, so it is where uploads cut
  // short by a reload / crash are picked up again.
  useEffect(() => { void restoreSavedUploads(); }, []);
  const active = jobs.filter(j => j.status === 'queued' || j.status === 'uploading').length;
  const toCheck = jobs.filter(j => j.status === 'review').length;
  if (active === 0) {
    // Nothing is running, but auto-separated files are waiting for their split to be checked.
    if (toCheck === 0) return null;
    return (
      <span
        className="upload-queue-indicator"
        role="status"
        title="Open Upload Docs and check how these files are split. They are not saved until you do."
      >
        {toCheck} {toCheck === 1 ? 'upload' : 'uploads'} to check
      </span>
    );
  }
  const finished = jobs.filter(j => j.status === 'done').length;
  return (
    <span
      className="upload-queue-indicator"
      role="status"
      title="Documents are uploading in the background. If this tab is closed before they finish, they continue the next time you open Akountant in this browser."
    >
      Uploading {finished + 1} of {finished + active}…
    </span>
  );
};

export default UploadQueueIndicator;
